import { EntityState } from '@ngrx/entity';
import { OrderReview } from '@app/resources/services';

export interface OrderReviewState extends EntityState<OrderReview> {
  selectedOrderReviewId: string | null;
  hasLoaded: boolean;
}
